(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('UnitsBatchAdministrationController', UnitsBatchAdministrationController);

    UnitsBatchAdministrationController.$inject = [
        '$scope',
        '$rootScope',
        'unitBatchService',
        'unitService',
        'formTypes',
        '$kWindow',
        '$translate'
    ];

    function UnitsBatchAdministrationController(
        $scope,
        $rootScope,
        unitBatchService,
        unitService,
        formTypes,
        $kWindow,
        $translate
    ) {
        const dateFormat = "dd. MMMM yyyy"

        $scope.showArchived = false;
        $scope.exportBatchCertificatesToZipFile = exportProductBatchFilesToZip;
        var exportLoadPanelInstance = null;

        $scope.gridColumns = [
            {
                type: "selection",
                fixed: true,
                fixedPosition: "left",
                allowExporting: false,
                showInColumnChooser: false,
                allowResizing: false,
                width: 35
            },
            {
                fixed: true,
                fixedPosition: "left",
                width: 70,
                allowExporting: false,
                allowResizing: false,
                showInColumnChooser: false,
                type: "buttons",
                buttons: [
                    {
                        icon: "edit",
                        hint: $translate.instant('ADMIN_UNITS_EDIT_UNIT_BATCH'),
                        name: "change",
                        onClick: function(e) {
                            var windowInstance = $kWindow.open({
                                options: {
                                    modal: true,
                                    movable: false,
                                    title: $translate.instant('ADMIN_UNITS_EDIT_UNIT_BATCH'),
                                    resizable: true,
                                    width: 520,
                                    visible: false
                                },
                                templateUrl: 'app/units/units-batch-details-modal-administration-view.html',
                                windowTemplateUrl: 'app/shared/modal-base.html',
                                controller: 'unitsBatchDetailsModalAdministrationController',
                                resolve: {
                                    currentFormType: () => formTypes.edit,
                                    unitId: null,
                                    unitBatchId: () => e.row.data.id
                                }
                            });

                            windowInstance.result.then(function (result) {
                                if (result) {
                                    $scope.unitBatchAdministrationGrid.refresh();
                                }
                            });
                        }
                    }
                ]
            },
            {
                dataField: "batch",
                width: 160,
                caption: $translate.instant("ADMIN_UNITS_BATCH_NUMBER")
            },
            {
                dataField: "resourceDescription",
                width: 120,
                caption: $translate.instant("ADMIN_UNITS_RESOURCE")
            },
            {
                dataField: "unitDescription",
                width: 160,
                caption: $translate.instant("ADMIN_UNITS_PRODUCT_NAME")
            },
            {
                dataField: "supplierName",
                width: 160,
                caption: $translate.instant("ADMIN_UNITS_SUPPLIER")
            },
            {
                dataField: "isActive",
                width: 80,
                caption: $translate.instant("G_ACTIVE")
            },
            {
                dataField: "hasFile",
                width: 140,
                caption: $translate.instant("ADMIN_UNITS_HAS_CERTIFICATE_FILE")
            },
            {
                dataField: "lifetimeInYearsMooring",
                width: 160,
                caption: $translate.instant("ADMIN_UNITS_LIFETIME_IN_YEARS_MOORING"),
                dataType: "number"
            },
            {
                dataField: "lifetimeInYearsBridles",
                width: 160,
                caption: $translate.instant("ADMIN_UNITS_LIFETIME_IN_YEARS_BRIDLE"),
                dataType: "number"
            },
            {
                dataField: "certificateIssuedDate",
                format: dateFormat,
                dataType: "date",
                width: 160,
                caption: $translate.instant("UNIT_BATCH_CERTIFICATE_ISSUED_DATE")
            },
            {
                width: 120,
                caption: $translate.instant("ADMIN_UNITS_LOCATIONS"),
                name: "locations",
                allowExporting: false,
                calculateFilterExpression: function(filterValue) {
                    if (Array.isArray(filterValue)) {
                        // multiple selected
                        var predicates = filterValue.map(function(val) {
                            if (val === "") {
                                return function(row) {
                                    return !row.locations || row.locations.length === 0;
                                };
                            }

                            return function(row) {
                                return row.locations && row.locations.some(function(loc) {
                                    return String(loc.locationNumber) === val;
                                });
                            };
                        });

                        return function(row) {
                            return predicates.some(function(fn) { return fn(row); });
                        };
                    }

                    // single selection
                    if (filterValue === "") {
                        return function(row) {
                            return !row.locations || row.locations.length === 0;
                        };
                    }
                    return function(row) {
                        return row.locations && row.locations.some(function(loc) {
                            return String(loc.locationNumber) === filterValue;
                        });
                    };
                },
                cellTemplate: function (container, options) {
                    let locationsArray = options.data.locations;
                    if (Array.isArray(locationsArray) && locationsArray.length > 0) {
                        dxjQuery("<div>").dxButton({
                            text: `${$translate.instant("G_SHOW")} (${locationsArray.length})`,
                            height: "1.8rem",
                            width: "100%",
                            onClick: function (e) {
                                e.event.stopPropagation();
                                showListPopup(locationsArray.map(location => `${location.locationName} - ${location.locationNumber}`), e.element);
                            }
                        }).appendTo(container);
                    }
                }
            },
            {
                dataField: "createdBy",
                caption: $translate.instant("G_CREATED_BY"),
                visible: false
            },
            {
                dataField: "createdOn",
                dataType: "date",
                format: dateFormat,
                caption: $translate.instant("G_CREATED_ON"),
                visible: false
            }
        ]

        $scope.gridOptions = {
            name: "UnitBatchAdministrationGrid",
            columns: $scope.gridColumns,
            dataSource: new DevExpress.data.CustomStore({
                load: () => unitBatchService.getUnitBatches(!$scope.showArchived),
                onLoaded: (data) => {
                    // Populate locations column grid dropdown with unique values
                    var uniqueLocations = {};

                    data.forEach(function(row) {
                        if (Array.isArray(row.locations)) {
                            row.locations.forEach(function(location) {
                                var locationKey = String(location.locationNumber);
                                if (!uniqueLocations.hasOwnProperty(locationKey)) {
                                    uniqueLocations[locationKey] = location.locationName;
                                }
                            });
                        }
                    });

                    $scope.unitBatchAdministrationGrid.columnOption("locations", "headerFilter", {
                        dataSource: [
                            { text: `(${$translate.instant("G_EMPTY")})`, value: "" },
                            ..._.sortBy(
                                Object.keys(uniqueLocations).map(keyStr => ({
                                    text: uniqueLocations[keyStr],
                                    value: keyStr
                                })),
                                "text"
                            )
                        ]
                    });
                }
            }),
            multiSelectActions: [
                // Archive selected batches
                {
                    location: "center",
                    widget: "dxButton",
                    cssClass: "archiveSelectedButton",
                    name: "archiveSelected",
                    options: {
                        text: $translate.instant("ADMIN_UNITS_ARCHIVE_UNIT_BATCHES"),
                        type: "default",
                        onClick: function() {
                            archiveSelectedBatches($scope.unitBatchAdministrationGrid.getSelectedRowsData());
                            $scope.unitBatchAdministrationGrid.multiSelectPopup.hide();
                        }
                    },
                    visible: !$scope.showArchived
                },
                // Move selected batches
                {
                    location: "center",
                    widget: "dxButton",
                    options: {
                        text: $translate.instant("ADMIN_UNITS_MOVE_UNIT_BATCHES"),
                        type: "default",
                        onClick: function() {
                            moveSelectedBatches($scope.unitBatchAdministrationGrid.getSelectedRowsData())
                            $scope.unitBatchAdministrationGrid.multiSelectPopup.hide();
                        }
                    },
                    visible: !$scope.showArchived
                }
            ],
            getMultiSelectVisibilityFn: () => !$scope.showArchived,
            toolbarActions: [
                // Add new unit batch
                {
                    widget: "dxButton",
                    options: {
                        icon:"add",
                        onClick: function (event) {
                            var windowInstance = $kWindow.open({
                                options: {
                                    modal: true,
                                    movable: false,
                                    title: $translate.instant('ADMIN_UNITS_ADD_UNIT_BATCH'),
                                    resizable: true,
                                    width: 520,
                                    visible: false
                                },
                                templateUrl: 'app/units/units-batch-details-modal-administration-view.html',
                                windowTemplateUrl: 'app/shared/modal-base.html',
                                controller: 'unitsBatchDetailsModalAdministrationController',
                                resolve: {
                                    currentFormType: () => formTypes.add,
                                    unitId: () => null,
                                    unitBatchId: () => null
                                }
                            });

                            windowInstance.result.then(function (result) {
                                if (result) {
                                    $scope.unitBatchAdministrationGrid.refresh();
                                }
                            });
                        },
                        text: $translate.instant('ADMIN_UNITS_ADD_UNIT_BATCH')

                    },
                    locateInMenu: "never",
                },
                // Toggle displaying active and archived unit batches
                {
                    widget: "dxButton",
                    options: {
                        onClick: function (event) {
                            $scope.showArchived = !$scope.showArchived;
                            $scope.unitBatchAdministrationGrid.clearFilter();
                            $scope.unitBatchAdministrationGrid.clearSorting();
                            $scope.unitBatchAdministrationGrid.refresh();

                            event.component.option("text", $scope.showArchived ? $translate.instant("G_SHOW_ACTIVE") : $translate.instant("G_SHOW_ARCHIVED"));
                            dxjQuery('.archiveSelectedButton').toggle(!$scope.showArchived)
                        },
                        text: $scope.showArchived ? $translate.instant("G_SHOW_ACTIVE") : $translate.instant("G_SHOW_ARCHIVED")
                    },
                    locateInMenu: "never",
                },
                {
                    //export to zip archive
                    widget: "dxButton",
                    options: {
                        onClick: exportProductBatchFilesToZip,
                        text: $translate.instant("ADMIN_UNIT_BATCH_EXPORT_CERTIFICATES"),
                        title: $translate.instant("ADMIN_UNIT_BATCH_EXPORT_CERTIFICATES") //tooltip - not called title?
                    },
                    locateInMenu: "never"
                }
            ]
        }

        function exportProductBatchFilesToZip() {
            const gridInstance = $scope.unitBatchAdministrationGrid;

            initializeExportLoadPanel();
            exportLoadPanelInstance.option("message", $translate.instant("ADMIN_UNIT_BATCH_EXPORT_DOWNLOAD_STARTS"));
            exportLoadPanelInstance.show();

            // Disabling built in loading spinner temporarily, so we don't see the load when rows are selected
            const originalLoadPanelSetting = gridInstance.option("loadPanel.enabled");
            gridInstance.option("loadPanel.enabled", false);

            gridInstance.selectAll()
                .then(function() {
                    const selectedRows = gridInstance.getSelectedRowsData();
                    var itemsToExport = selectedRows.filter(item => item.hasFile && item.mediaId);

                    return gridInstance.deselectAll().then(() => itemsToExport);
                })
                .then(function(itemsToExport) {
                    if (!itemsToExport || itemsToExport.length === 0) {
                        notify($translate.instant("ADMIN_UNIT_BATCH_EXPORT_NO_FILES_TO_EXPORT"), 'info');
                        throw 'NO_FILES_SELECTED';
                    }

                    return unitBatchService.exportBatchCertificatesToZipFile(itemsToExport);
                })
                .then(function(arrayBuffer) {
                    // Verify you received an ArrayBuffer
                    if (!(arrayBuffer instanceof ArrayBuffer)) {
                        console.error("Expected ArrayBuffer, but received:", typeof arrayBuffer, arrayBuffer);
                        notify(`${$translate.instant("ADMIN_UNIT_BATCH_EXPORT_ERROR")}: ${"ADMIN_UNIT_BATCH_EXPORT_ERROR_WRONG_FILE_FORMAT"}`, 'error');
                        return; // Stop execution if the format is wrong
                    }

                    if (arrayBuffer && arrayBuffer.byteLength === 0) {
                        notify(`${$translate.instant("ADMIN_UNIT_BATCH_EXPORT_NO_FILES_TO_EXPORT")}`, 'info');
                        return; // Stop execution if the file is empty
                    }

                    // Create a Blob directly from the ArrayBuffer
                    const blob = new Blob([arrayBuffer], { type: 'application/zip' });

                    // Create an object URL for the blob
                    const url = URL.createObjectURL(blob);

                    const today = getFormattedDateAndTime();
                    const zipFileName = `ProductBatchFiles_${today}.zip`;

                    // Use helper function to trigger download
                    downloadBlobUrl(url, zipFileName);

                    notify($translate.instant("ADMIN_UNIT_BATCH_EXPORT_DOWNLOAD_COMPLETE"), 'success');
                })
                .catch(function(error) {
                    if (error === 'NO_FILES_SELECTED') {
                        // Notification already shown, just prevent further error messages
                        return;
                    }

                    console.error("Export error details:", error);
                    notify(`${$translate.instant("ADMIN_UNIT_BATCH_EXPORT_ERROR")}: ${error.data}`, 'error');
                })
                .always(function() {
                    if (gridInstance) {
                        gridInstance.option("loadPanel.enabled", originalLoadPanelSetting);
                    }
                    if (exportLoadPanelInstance) {
                        exportLoadPanelInstance.hide();
                    }
                });
        }

        function initializeExportLoadPanel() {
            if (!exportLoadPanelInstance) {
                const loadPanelElement = dxjQuery("#export-load-panel");
                if (loadPanelElement.length) {
                    exportLoadPanelInstance = loadPanelElement.dxLoadPanel({
                        shadingColor: "rgba(0,0,0,0.4)",
                        position: { of: '#unitBatchAdministrationGrid' },
                        visible: false,
                        showIndicator: true,
                        showPane: true,
                        shading: true,
                        closeOnOutsideClick: false,
                        message: "Processing..."
                    }).dxLoadPanel("instance");
                } else {
                    console.error("Could not find #export-load-panel element to initialize dxLoadPanel.");
                }
            }
        }

        // Helper function to handle the download
        function downloadBlobUrl(url, fileName) {
            // Create a link element
            const link = document.createElement('a');

            // Set link properties
            link.href = url;
            link.download = fileName;
            link.style.display = 'none';

            // Add to document, trigger click, then remove
            document.body.appendChild(link);
            link.click();

            // Clean up - remove the link and revoke the object URL
            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }, 100);
        }

        function getFormattedDateAndTime() {
            var today = new Date();

            return "".concat(
                today.getFullYear(),
                getPaddedNumber(today.getMonth() + 1, 2), //stupid javascript month is 0-based...huh...
                getPaddedNumber(today.getDate(), 2),
                '_',
                getPaddedNumber(today.getHours(), 2),
                getPaddedNumber(today.getMinutes(), 2)
            );
        }

        function getPaddedNumber(numberToPad, numberOfDigits) {
            var numberWithLeadingZero = "".concat('0', numberToPad);
            return numberWithLeadingZero.substring(numberWithLeadingZero.length - numberOfDigits)
        }

        function notify(message, level) {
            DevExpress.ui.notify({
                message,
                position: {
                    my: 'center top',
                    at: 'center top',
                },
            }, level, 5000);
        }

        function archiveSelectedBatches(selectedRows) {
            let archiveBatchesPopup = dxjQuery("#archive-batches-popup").dxPopup({
                animation: null,
                showTitle: true,
                showCloseButton: false,
                title: $translate.instant("G_CONFIRM_ACTION"),
                minWidth: 400,
                width: '50vw',
                contentTemplate: function(contentElement) {
                    // Confirm archiving
                    contentElement.append(
                        dxjQuery("<div>").attr("style", "height:100%; display: flex; flex-direction: column;")
                        .append(
                            dxjQuery("<p>").text($translate.instant("ADMIN_UNIT_BATCH_ARCHIVE_CONFIRM_MESSAGE")),
                            dxjQuery("<div>").css({ "flex-grow": "1", "overflow": "auto"}).dxDataGrid({
                                height: "100%",
                                dataSource: selectedRows,
                                showBorders: true,
                                columns: [
                                    { dataField: "batch", caption: $translate.instant("ADMIN_UNITS_BATCH_NUMBER") },
                                    { dataField: "unit.description", caption: $translate.instant("ADMIN_UNITS_PRODUCT_NAME") },
                                    { dataField: "unit.resource.resourceDescription", caption: $translate.instant("ADMIN_UNITS_RESOURCE") },
                                    { dataField: "unit.supplier.name", caption: $translate.instant("ADMIN_UNITS_SUPPLIER")  }
                                ],
                                scrolling: { mode: "virtual" }
                            })
                        )
                    );
                },
                visible: false,
                toolbarItems: [
                    {
                        widget: "dxButton",
                        toolbar: "bottom",
                        options: {
                            text: $translate.instant("G_YES"),
                            onClick: function() {
                                // Show loader and perform archive batches function
                                archiveBatchesPopup.option("title", "");
                                archiveBatchesPopup.option("toolbarItems", []);

                                archiveBatchesPopup.option("contentTemplate", function(contentElement) {
                                    contentElement.append(
                                        dxjQuery("<div>").dxLoadPanel({
                                            shading: false,
                                            showIndicator: true,
                                            showPane: false,
                                            visible: true,
                                            container: contentElement,
                                            message: $translate.instant("G_ACTION_IN_PROGRESS")
                                        })
                                    )
                                });

                                unitBatchService.bulkArchiveUnitBatches(selectedRows.map(unitBatch => unitBatch.id))
                                .then((result) => {
                                    // Show results
                                    archiveBatchesPopup.option("title", $translate.instant("G_ACTION_COMPLETED"));
                                    archiveBatchesPopup.option("toolbarItems", [
                                        {
                                            widget: "dxButton",
                                            toolbar: "bottom",
                                            options: {
                                                text: $translate.instant("G_OK"),
                                                onClick: function() {
                                                    $scope.unitBatchAdministrationGrid.refresh();
                                                    archiveBatchesPopup.hide();
                                                }
                                            }
                                        }
                                    ]);

                                    archiveBatchesPopup.option("contentTemplate", function(contentElement) {
                                        contentElement.append(
                                            dxjQuery("<div>").attr("style", "height:100%; display: flex; flex-direction: column;")
                                            .append(
                                                dxjQuery("<p>").text($translate.instant("ADMIN_UNIT_BATCH_ARCHIVE_RESULT_MESSAGE")),
                                                dxjQuery("<div>").css({ "flex-grow": "1", "overflow": "auto" }).dxDataGrid({
                                                    height: "100%",
                                                    dataSource: result,
                                                    columns: [
                                                        {
                                                            dataField: "details.batchName",
                                                            caption: "Batch",
                                                            sortIndex: 4,
                                                            sortOrder: "asc",
                                                        },
                                                        {
                                                            dataField: "details.unitDescription",
                                                            sortIndex: 3,
                                                            sortOrder: "asc",
                                                        },
                                                        {
                                                            dataField: "details.resourceDescription",
                                                            sortIndex: 2,
                                                            sortOrder: "asc",
                                                        },
                                                        {
                                                            dataField: "details.supplierName",
                                                            sortIndex: 1,
                                                            sortOrder: "asc",
                                                        },
                                                        {
                                                            dataField: "details.locationsInUse",
                                                            cellTemplate: function (container, options) {
                                                                if (Array.isArray(options.value) && options.value.length > 0) {
                                                                    dxjQuery("<div>").dxButton({
                                                                        text: `${$translate.instant("G_SHOW")} (${options.value.length})`,
                                                                        onClick: function (e) {
                                                                            showListPopup(options.value, e.element);
                                                                        }
                                                                    }).appendTo(container);
                                                                }
                                                            }
                                                        },
                                                        {
                                                            dataField: "message",
                                                            caption: "Status",
                                                            groupIndex: 0
                                                        },
                                                        {
                                                            dataField: "statusCode",
                                                            caption: "Status Code",
                                                            sortIndex: 0,
                                                            sortOrder: "asc",
                                                            visible: false
                                                        }
                                                    ],
                                                    summary: {
                                                        groupItems: [
                                                            { column: "message", summaryType: "count", displayFormat: "{0}" }
                                                        ]
                                                    },
                                                    showBorders: true,
                                                    scrolling: { mode: "virtual" },
                                                    grouping: {
                                                        autoExpandAll: false,
                                                        expandMode: "rowClick"
                                                    },
                                                    showColumnHeaders: false
                                                })
                                            )
                                        );
                                    });
                                    archiveBatchesPopup.show();
                                })
                                .catch((error) => {
                                    // Handle error and display error message
                                    archiveBatchesPopup.option("title", $translate.instant("G_ACTION_FAILED_TITLE"));
                                    archiveBatchesPopup.option("toolbarItems", [
                                        {
                                            widget: "dxButton",
                                            toolbar: "bottom",
                                            options: {
                                                text: $translate.instant("G_OK"),
                                                onClick: function() {
                                                    archiveBatchesPopup.hide();
                                                }
                                            }
                                        }
                                    ]);

                                    archiveBatchesPopup.option("contentTemplate", function(contentElement) {
                                        contentElement.append(dxjQuery("<p />").text($translate.instant("G_UNEXPECTED_ERROR")));
                                    });
                                });
                            }
                        }
                    },
                    {
                        widget: "dxButton",
                        toolbar: "bottom",
                        options: {
                            text: $translate.instant("G_NO"),
                            onClick: function() {
                                archiveBatchesPopup.hide();
                            }
                        }
                    }
                ]
            }).dxPopup("instance");

            // Show the popup (confirmation dialog)
            archiveBatchesPopup.show();
        }

        function moveSelectedBatches(selectedRows) {
            unitService
            .getUnitsAsDropdownByContractorId($rootScope.authData.contractorId)
            .then((result) => {
                var windowInstance = $kWindow.open({
                    options: {
                        modal: true,
                        movable: false,
                        title: $translate.instant('ADMIN_UNITS_MOVE_UNIT_BATCHES'),
                        resizable: true,
                        width: 520,
                        visible: false
                    },
                    templateUrl: 'app/units/move-units-batch-modal.html',
                    windowTemplateUrl: 'app/shared/modal-base.html',
                    controller: 'moveUnitsBatchModalController',
                    resolve: {
                        units: () => result.filter(unit => unit.isActive),
                        unitId: () => selectedRows[0].unitId,
                        selectedUnitsbatches: () => selectedRows
                    }
                });

                windowInstance.result.then(function (result) {
                    if (result) {
                        $scope.unitBatchAdministrationGrid.refresh();
                    }
                });
            })
            .catch((error) => console.error(error));
        }

        // Shows a popup displaying listElements at targetElement
        function showListPopup(listElements, targetElement) {
            let popup = dxjQuery("<div>").appendTo("body").dxPopup({
                animation: null,
                height: "auto",
                maxHeight: "50rem",
                width: "30rem",
                hideOnOutsideClick: true,
                position: {
                    my: "top right",
                    at: "bottom right",
                    of: targetElement,
                    boundary: window,
                    collision: "flipfit"
                },
                contentTemplate: function () {
                    return dxjQuery("<div>").dxList({
                        dataSource: listElements
                    });
                },
                showCloseButton: false,
                showTitle: false,
                onHidden: function (e) {
                    e.component.element().remove();
                    e.component.dispose();
                }
            }).dxPopup("instance");

            popup.show();
        }

        $scope.onGridInit = function (grid) {
            grid.option({
                selection: { allowSelectAll: false }
            });
        }

    }
})();
